import styled from "styled-components";
import { Container } from "reactstrap";
import ProfileMenu from "_c/ProfileMenu";

export const StyledProfileMenu = styled(ProfileMenu)`
  @media (max-width: ${({ theme }) => theme.mobileBp}) {
    margin-top: 45px;
    margin-bottom: 5px;
  }
`;

export const ItemsContainer = styled(Container)`
  overflow: visible !important;
`;
